import { createContext } from "react";
export var TableContext = createContext({
    scrollStatus: "left",
    columnsWidths: [],
});
//# sourceMappingURL=TableContext.js.map